import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/test/click-error')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex flex-col items-center justify-center">
      <button
        onClick={() => {
          throw new Error('手动报错')
        }}
      >
        手动报错
      </button>
    </div>
  )
}
